"use strict";
import { __exports as u } from "./index.es351.js";
var _;
function g() {
  return _ ? u : (_ = 1, (function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    });
    function a(e, n) {
      for (var t in n) Object.defineProperty(e, t, {
        enumerable: !0,
        get: n[t]
      });
    }
    a(i, {
      DEFAULT_SEGMENT_KEY: function() {
        return E;
      },
      PAGE_SEGMENT_KEY: function() {
        return r;
      },
      addSearchParamsIfPageSegment: function() {
        return s;
      },
      isGroupSegment: function() {
        return c;
      },
      isParallelRouteSegment: function() {
        return f;
      }
    });
    function c(e) {
      return e[0] === "(" && e.endsWith(")");
    }
    function f(e) {
      return e.startsWith("@") && e !== "@children";
    }
    function s(e, n) {
      if (e.includes(r)) {
        const o = JSON.stringify(n);
        return o !== "{}" ? r + "?" + o : r;
      }
      return e;
    }
    const r = "__PAGE__", E = "__DEFAULT__";
  })(u), u);
}
export {
  g as __require
};
//# sourceMappingURL=index.es349.js.map
